import React from 'react';
import { Button, Table, Modal, ProgressBar, Form } from 'react-bootstrap';
import Moment from 'moment';

import Const from '../../../../../util/Constants';
import Util from '../../../../../util/Util';
import FacebookV2API from '../../../../../api/FacebookV2API';
import withRouter from '../../../../../util/WithRouter';

// Server stays UTC; only this column renders IST
const istFormat = iso => Moment.utc(iso).add(5, 'hours').add(30, 'minutes').format('DD/MM/YYYY HH:mm');
const istDayStartUnix = d => Math.floor(Moment.utc(d + 'T00:00:00').subtract(5, 'hours').subtract(30, 'minutes').valueOf() / 1000);
const istDayEndUnix   = d => Math.floor(Moment.utc(d + 'T00:00:00').add(18, 'hours').add(30, 'minutes').valueOf() / 1000);

class FacebookBackfill extends React.Component {
  constructor(props) {
    super(props);
    this.mappingId = parseInt(props.match?.params?.mappingId || 0);
    const todayIST = Moment.utc().add(5, 'hours').add(30, 'minutes');
    this.state = {
      mappingName: '',
      fromStr: todayIST.clone().subtract(90, 'days').format('YYYY-MM-DD'),
      toStr: todayIST.format('YYYY-MM-DD'),
      from: 0, to: 0,
      rows: [],
      after: null, has_next: false, page: 1,
      inApiCall: false,
      selectAllLoading: false,
      allMatchingSelected: false,
      selected: {},
      showConfirm: false,
      importing: false,
      progress: { total: 0, done: 0, created: 0, dup_noted: 0, skipped_incomplete: 0, failed: 0 },
      columns: [],
      importKey: 'phone',
    };
    this.cursorHistory = [];
    this.currentCursor = null;
    this.presentCount = 0;
  }

  componentDidMount() {
    FacebookV2API.getMapping(this.mappingId,
      api => this.setState({ mappingName: api.name || '' }, () => this.applyFilter()),
      () => this.applyFilter());
  }

  applyFilter = () => {
    this.cursorHistory = [];
    this.currentCursor = null;
    this.setState({
      from: istDayStartUnix(this.state.fromStr),
      to: istDayEndUnix(this.state.toStr),
      page: 1, selected: {}, allMatchingSelected: false
    }, () => this.loadPage(null));
  };

  loadPage = cursor => {
    this.currentCursor = cursor;
    this.setState({ inApiCall: true });
    FacebookV2API.backfillLeads({
      mapping_id: this.mappingId, from: this.state.from, to: this.state.to, cursor, limit: 25
    }, res => {
      this.setState({
        rows: res.rows || [],
        columns: res.columns || [],
        importKey: res.import_key || 'phone',
        after: res.paging?.after || null,
        has_next: !!res.paging?.has_next,
        inApiCall: false
      });
    }, err => {
      Util.showError(err.message || 'Failed to load leads');
      this.setState({ inApiCall: false });
    });
  };

  nextPage = () => {
    this.cursorHistory.push(this.currentCursor);
    this.setState({ page: this.state.page + 1 });
    this.loadPage(this.state.after);
  };

  prevPage = () => {
    const c = this.cursorHistory.pop();
    this.setState({ page: Math.max(1, this.state.page - 1) });
    this.loadPage(c === undefined ? null : c);
  };

  // ---------- selection ----------
  pageAllSelected = () => {
    const sel = this.pageSelectable();
    return sel.length > 0 && sel.every(r => this.state.selected[r.lead_id]);
  };

  toggleRow = row => {
    if (!this.isImportable(row)) return;
    const selected = { ...this.state.selected };
    if (selected[row.lead_id]) delete selected[row.lead_id];
    else selected[row.lead_id] = row;
    this.setState({ selected });
  };

  togglePage = () => {
    const selected = { ...this.state.selected };
    if (this.pageAllSelected()) this.pageSelectable().forEach(r => delete selected[r.lead_id]);
    else this.pageSelectable().forEach(r => selected[r.lead_id] = r);
    this.setState({ selected });
  };

  selectAllMatching = () => {
    this.setState({ selectAllLoading: true });
    const selected = { ...this.state.selected };
    const walk = cursor => {
      FacebookV2API.backfillLeads({
        mapping_id: this.mappingId, from: this.state.from, to: this.state.to, cursor, limit: 100
      }, res => {
        (res.rows || []).forEach(r => { 
          if (this.isImportable(r)) selected[r.lead_id] = r;  // CHANGED
        });
        if (res.paging && res.paging.has_next) walk(res.paging.after);
        else this.setState({ selected, selectAllLoading: false, allMatchingSelected: true });
      }, err => {
        Util.showError(err.message || 'Failed to select all');
        this.setState({ selectAllLoading: false });
      });
    };
    walk(null);
  };

  askImport = () => {
    const sel = Object.values(this.state.selected);
    this.presentCount = sel.filter(r => r.is_present).length;
    this.setState({ showConfirm: true });
  };

  startImport = () => {
    const ids = Object.keys(this.state.selected);
    this.setState({
      showConfirm: false, importing: true,
      progress: { total: ids.length, done: 0, created: 0, dup_noted: 0, skipped_incomplete: 0, failed: 0 }
    });
    this.runChunks(ids);
  };

  runChunks = ids => {
    if (ids.length === 0) {
      const p = this.state.progress;
      Util.showNotification('Import complete',
        `Created ${p.created}, notes added ${p.dup_noted}, skipped incomplete ${p.skipped_incomplete}, failed ${p.failed}`, 'success');
      this.setState({ importing: false, selected: {}, allMatchingSelected: false });
      this.loadPage(this.currentCursor);   // refresh badges: imported leads now show "Already in CRM"
      return;
    }
    const chunk = ids.slice(0, 50);
    const rest = ids.slice(50);
    FacebookV2API.backfillRun({ mapping_id: this.mappingId, ids: chunk }, res => {
      const p = this.state.progress;
      this.setState({
        progress: {
          ...p,
          done: p.done + chunk.length,
          created: p.created + (res.created || 0),
          dup_noted: p.dup_noted + (res.dup_noted || 0),
          skipped_incomplete: p.skipped_incomplete + (res.skipped_incomplete || 0),
          failed: p.failed + (res.failed || 0)
        }
      }, () => this.runChunks(rest));
    }, err => {
      Util.showError('Import stopped: ' + (err.message || err));
      this.setState({ importing: false });
    });
  };

  badge = (row, importable) => {
    if (!importable) return <span className="badge badge-secondary">Incomplete (No Phone)</span>;
    if (row.is_present) return <span className="badge badge-warning">Already in CRM</span>;
    return <span className="badge badge-success">New</span>;
  };

  isImportable = row => !!((row.fields[this.state.importKey] || '').toString().trim());

  pageSelectable = () => this.state.rows.filter(r => this.isImportable(r));

  render() {
    const { rows, selected, inApiCall, importing, progress, has_next, page } = this.state;
    const selectedCount = Object.keys(selected).length;
    const pct = progress.total ? Math.round((progress.done / progress.total) * 100) : 0;

    const istFormat = iso => Moment.utc(iso).add(5, 'hours').add(30, 'minutes').format('DD/MM/YYYY HH:mm');
    const istDayStartUnix = d => Math.floor(Moment.utc(d + 'T00:00:00').subtract(5, 'hours').subtract(30, 'minutes').valueOf() / 1000);
    const istDayEndUnix = d => Math.floor(Moment.utc(d + 'T00:00:00').add(18, 'hours').add(30, 'minutes').valueOf() / 1000);

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-8 pb-3">
              <h3>Import Past Leads {this.state.mappingName ? `— ${this.state.mappingName}` : ''}</h3>
            </div>
            <div className="col-md-4 pb-3 text-right">
              <Button variant="link" onClick={() => this.props.navigate('/facebook')}>← Back to Facebook</Button>
            </div>
          </div>

          {/* <div className="text-muted small pb-3">
            Facebook retains leads for ~90 days only. Leads submitted before the form's last edit may lack
            newer questions — those CRM fields will be blank. Incomplete leads (missing name, email or phone)
            cannot be imported.
          </div> */}

          {/* Filters */}
          <div className="row pb-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From</Form.Label>
                <Form.Control type="date" value={this.state.fromStr}
                  onChange={e => this.setState({ fromStr: e.target.value })} />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To</Form.Label>
                <Form.Control type="date" value={this.state.toStr}
                  onChange={e => this.setState({ toStr: e.target.value })} />
              </Form.Group>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <Button variant="primary" onClick={this.applyFilter} disabled={inApiCall || importing}>Apply</Button>
            </div>
          </div>

          {/* Gmail-style select-all banner */}
          { this.pageAllSelected() && !this.state.allMatchingSelected &&
            <div className="alert alert-info py-2">
              All {this.pageSelectable().length} leads on this page are selected.{' '}
              <Button size="sm" variant="link" className="p-0"
                disabled={this.state.selectAllLoading || importing}
                onClick={this.selectAllMatching}>
                {this.state.selectAllLoading ? 'Loading...' : 'Select all leads matching this filter'}
              </Button>
            </div>
          }

          {/* Table */}
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th style={{ width: '40px' }}>
                  <input type="checkbox" checked={this.pageAllSelected()} onChange={this.togglePage} />
                </th>
                <th>Date (IST)</th>
                { this.state.columns.map(c => <th key={c.key}>{c.label}</th>) }
                <th>Campaign / Ad</th>
                <th>Platform</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              { rows.map(row => {
                const importable = this.isImportable(row);
                return (
                  <tr key={row.lead_id}>
                    <td>
                      <input type="checkbox" disabled={!importable}
                        checked={!!selected[row.lead_id]} onChange={() => this.toggleRow(row)} />
                    </td>
                    <td>{istFormat(row.created_time)}</td>
                    { this.state.columns.map(c =>
                      <td key={c.key}>
                        { (row.fields[c.key] || '').toString() || <i className="text-muted">—</i> }
                      </td>
                    )}
                    <td>{row.campaign_name}{row.ad_name ? ` / ${row.ad_name}` : ''}</td>
                    <td>{row.platform}</td>
                    <td>{this.badge(row, importable)}</td>
                  </tr>
                );
              })}
              { !inApiCall && rows.length === 0 &&
                <tr><td colSpan={this.state.columns.length + 5} className="text-center text-muted">No leads in this range.</td></tr>
              }
            </tbody>
          </Table>

          {/* Paging */}
          <div className="d-flex justify-content-between align-items-center pb-3">
            <Button size="sm" variant="secondary" disabled={page === 1 || inApiCall || importing} onClick={this.prevPage}>← Prev</Button>
            <span className="text-muted small">Page {page}</span>
            <Button size="sm" variant="secondary" disabled={!has_next || inApiCall || importing} onClick={this.nextPage}>Next →</Button>
          </div>

          {/* Import bar + progress */}
          <div className="d-flex align-items-center mt-3">
            <Button variant="success" disabled={selectedCount === 0 || importing} onClick={this.askImport}>
              Import {selectedCount > 0 ? `(${selectedCount})` : ''}
            </Button>
            { importing &&
              <div className="flex-grow-1 ml-3">
                <ProgressBar now={pct} label={`${pct}%`} />
                <div className="small text-muted mt-1">
                  {progress.done}/{progress.total} processed — created {progress.created},
                  notes added {progress.dup_noted}, skipped incomplete {progress.skipped_incomplete},
                  failed {progress.failed}
                </div>
              </div>
            }
          </div>
        </div>

        {/* Soft confirmation */}
        <Modal show={this.state.showConfirm} onHide={() => this.setState({ showConfirm: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Import past leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>You are about to import <b>{selectedCount}</b> leads into the CRM.</p>
            { this.presentCount > 0 &&
              <p className="text-warning">
                {this.presentCount} of these already exist in the CRM — their data will be added
                as notes on the existing leads.
              </p>
            }
            <p className="text-muted small">
              Leads missing the required field ({this.state.importKey}) are excluded automatically and cannot be selected.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfirm: false })}>Cancel</Button>
            <Button variant="success" onClick={this.startImport}>Import</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(FacebookBackfill);